import { Separator } from "@gigpro/ui/Separator";
import { getNextPageParam, useStafferGigsHistoryBySkillListInfinite } from "@sidegigllc/api/client";
import {
  PROfileGigHistoryDetail,
  PROfileGigHistoryDetailSkeleton,
} from "domains/pros/components/PROfileGigHistoryDetail";
import type React from "react";
import InfiniteScroll from "react-infinite-scroller";
import { times } from "remeda";

type PROfileGigHistoryDetailContainerProps = { proId: number; skillId: number };

export const PROfileGigHistoryDetailContainer: React.FC<PROfileGigHistoryDetailContainerProps> = ({
  proId,
  skillId,
}) => {
  const { data, hasNextPage, isFetchingNextPage, fetchNextPage } = useStafferGigsHistoryBySkillListInfinite(
    { ordering: "-created_ts", page_size: 10, pro_id: proId, skill_id: [skillId] },
    { query: { getNextPageParam } },
  );
  const gigs = data?.pages.flatMap(({ results }) => results.map((gig) => ({ ...gig, rating: gig.rating ?? 0 })));
  return gigs ? (
    <div className="mt-2 mb-4 max-h-72 overflow-auto px-3">
      <InfiniteScroll
        hasMore={!!hasNextPage}
        loadMore={() => {
          if (!isFetchingNextPage) void fetchNextPage();
        }}
        loader={<PROfileGigHistoryDetailSkeleton key="loader" />}
        useWindow={false}
      >
        {gigs.map((gig, index) => (
          <PROfileGigHistoryDetail key={gig.id} gig={gig} previousGig={gigs[index - 1]} />
        ))}
        <Separator />
      </InfiniteScroll>
    </div>
  ) : (
    times(3, (i) => <PROfileGigHistoryDetailSkeleton key={i} />)
  );
};
